



























































































import Vue, { PropOptions } from 'vue';
import '@/static/globals.css';

type CollapseProps = Blok & {
  title: string;
  content: string;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<CollapseProps>,
  },
  data() {
    return {
      isOpen: false,
    };
  },
});
